import axios from "axios";
import router from "@/router";
import alert from "@/lang/AlertMessages.js";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (localStorage.pitmsToken) {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.pitmsToken;
}
axios.defaults.headers.common["Content-Type"] = "application/json";

export default {
  login({ dispatch, commit }, data) {
    commit("setLoginCheck", true);
    axios
      .post("Account/Login", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("identityX/setUserAccess", res.data);
        localStorage.setItem("pitmsToken", res.data.access_token);
        localStorage.setItem("userRoles", JSON.stringify(res.data.roles));
        localStorage.setItem(
          "selectedRole",
          JSON.stringify(res.data.defaultRoleId)
        );
        localStorage.setItem(
          "rolePermissions",
          JSON.stringify(res.data.permissions)
        );
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.access_token;
        router.push({ name: "Dashboard" }).catch(() => {});
        setTimeout(() => {
          commit("setSuccess", alert.success.login, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 800);
      });
  },

  // register({ dispatch, commit }, data) {
  //   commit("setLoginCheck", true);
  //   axios
  //     .post("register", data)
  //     .then((res) => {
  //       commit("authUser", res.data);
  //       localStorage.setItem("pitmsToken", res.data.access_token);
  //       axios.defaults.headers.common["Authorization"] =
  //         "Bearer " + res.data.access_token;
  //       router.push({ name: "Dashboard" }).catch(() => {});
  //       setTimeout(() => {
  //         commit("setSuccess", res.data.message, { root: true });
  //       }, 1000);
  //     })
  //     .catch((error) => {
  //       dispatch("errorPOSTHandler", error);
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         commit("setLoginCheck", false);
  //       }, 800);
  //     });
  // },

  resetPassword({ dispatch }, data) {
    axios
      .put("resetPassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.resetPassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  forgotPassword({ dispatch, commit }, data) {
    commit("setForgotBtn", true);
    axios
      .put("forgotPassword", data)
      .then((res) => {
        commit("setForgotCheck", false);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.forgotPassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setForgotBtn", false);
        }, 1000);
      });
  },

  logout({ commit }) {
    localStorage.removeItem("pitmsToken");
    localStorage.removeItem("user");
    axios.defaults.headers.common["Authorization"] = "";
    commit("clearAuth");
    router.push({ name: "Login" }).catch(() => {});
  },

  getCurrentUser({ dispatch, commit }) {
    axios
      .get("profile")
      .then((res) => {
        commit("setCurrentUser", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editProfile({ dispatch }, data) {
    axios
      .post("account/updateProfile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.editProfile,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editPassword({ dispatch }, data) {
    axios
      .post("account/changePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changePassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // profile Actions
  getCurrentPerson({ dispatch, commit }) {
    axios
      .get("reception/person/getCurrentPerson")
      .then((res) => {
        commit("setCurrentPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Alert and Errors Handler ------------------------------------------------------
  successPOSTHandler({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck", false, { root: true });
      }, 800);
      if (data.redirect && data.id) {
        setTimeout(() => {
          router.push({
            name: data.redirect,
            params: { id: data.id },
          });
        }, 2000);
      } else if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2000);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck", false, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
      commit("setPostCheck", false, { root: true });
    }
  },

  successPOSTHandlerSimple({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  successPOSTHandlerSilent({ commit }, data) {
    if (data.server && data.server.status === 200) {
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data) {
      commit("setError", data.server.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorPOSTHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (data.response.message && data.response.message != "") {
      commit("setError", data.response.message, { root: true });
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorGETHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },
};
